import { ComponentType } from "react";
import { Task, TaskType } from "@common/types/task";
import { AccrualReviewTaskBody } from "./AccrualReview/AccrualReviewTaskBody";
import { BalanceSheetTaskBody } from "./BalanceSheet/BalanceSheetTaskBody";
import { BillsTaskBody } from "./Bills/BillsTaskBody";
import { BrokenConnectionTaskBody } from "./BrokenConnection/BrokenConnectionTaskBody";
import { ConnectAccountTaskBody } from "./ConnectAccount/ConnectAccountTaskBody";
import { CounterpartiesTaskBody } from "./Counterparties/CounterpartiesTaskBody";
import { DocumentRetrievalTaskBody } from "./DocumentRetrieval/DocumentRetrievalTaskBody";
import { FinancialDocumentsTaskBody } from "./FinancialDocuments/FinancialDocumentsTaskBody";
import { Form1099TaskBody } from "./Form1099/Form1099TaskBody";
import { GetDocumentsTaskBody } from "./GetDocuments/GetDocumentsTaskBody";
import { IntegrationCoaMappingTaskBody } from "./IntegrationCoaMapping/IntegrationCoaMappingTaskBody";
import { InvoicesTaskBody } from "./Invoices/InvoicesTaskBody";
import { MapMigratedDataTaskBody } from "./MapMigratedData/MapMigratedDataTaskBody";
import { FileMigrationUploadTaskBody } from "./MigrationFileUpload/FileMigrationUploadTaskBody";
import { PlaidNewAccountsTaskBody } from "./PlaidNewAccounts/PlaidNewAccountsTaskBody";
import { ProfitLossActivationTaskBody } from "./ProfitLossActivation/ProfitLossActivationTaskBody";
import { ReconciliationTaskBody } from "./Reconciliation/ReconciliationTaskBody";
import { MilestoneReviewTaskBody } from "./ScheduleReview/MilestoneReviewTaskBody";
import { RecognitionReviewTaskBody } from "./ScheduleReview/RecognitionReviewTaskBody";
import { RuleSuggestedReviewTaskBody } from "./ScheduleReview/RuleSuggestedReviewTaskBody";
import { SuspiciousTransactionReviewTaskBody } from "./ScheduleReview/SuspiciousTransactionReviewTaskBody";
import { StatementsRefreshTaskBody } from "./StatementsRefresh/StatementsRefreshTaskBody";
import { TransactionReviewTaskBody } from "./Transactions/TransactionReviewTaskBody";
import { TransactionsTaskBody } from "./Transactions/TransactionsTaskBody";

export interface TaskBodyProps {
    selectedTask: Task;
}

type TaskBodyComponent = ComponentType<TaskBodyProps>;

export const TASK_BODY_BY_TASK_TYPE: Record<
    TaskType,
    TaskBodyComponent | null
> = {
    [TaskType.TRANSACTIONS]: TransactionsTaskBody,
    [TaskType.TRANSACTION_REVIEW]: TransactionReviewTaskBody,
    [TaskType.ACCRUAL_REVIEW]: AccrualReviewTaskBody,
    [TaskType.SCHEDULE_SUSPICIOUS_TRANSACTION_REVIEW]:
        SuspiciousTransactionReviewTaskBody,
    [TaskType.SCHEDULE_RULE_SUGGESTED_REVIEW]: RuleSuggestedReviewTaskBody,
    [TaskType.REVENUE_RECOGNITION_REVIEW]: RecognitionReviewTaskBody,
    [TaskType.MILESTONE_REVENUE_RECOGNITION_REVIEW]: MilestoneReviewTaskBody,
    [TaskType.CONNECTION_BROKEN]: BrokenConnectionTaskBody,
    [TaskType.PLAID_STATEMENTS_REFRESH]: StatementsRefreshTaskBody,
    [TaskType.PLAID_NEW_ACCOUNTS_AVAILABLE]: PlaidNewAccountsTaskBody,
    [TaskType.PROFIT_LOSS_ACTIVATION]: ProfitLossActivationTaskBody,
    [TaskType.PROFIT_LOSS]: ProfitLossActivationTaskBody,
    [TaskType.CONNECT_ACCOUNT]: ConnectAccountTaskBody,
    [TaskType.MAP_MIGRATED_DATA]: MapMigratedDataTaskBody,
    [TaskType.DOCUMENT_RETRIEVAL]: DocumentRetrievalTaskBody,
    [TaskType.GET_DOCUMENTS]: GetDocumentsTaskBody,
    [TaskType.BALANCE_SHEET]: BalanceSheetTaskBody,
    [TaskType.FORM_1099]: Form1099TaskBody,
    [TaskType.COUNTERPARTIES]: CounterpartiesTaskBody,
    [TaskType.BILLS]: BillsTaskBody,
    [TaskType.INVOICES]: InvoicesTaskBody,
    [TaskType.FINANCIAL_DOCUMENTS]: FinancialDocumentsTaskBody,
    [TaskType.RECONCILIATION]: ReconciliationTaskBody,
    [TaskType.FILE_MIGRATION_UPLOAD]: FileMigrationUploadTaskBody,
    [TaskType.INTEGRATION_COA_MAPPING]: IntegrationCoaMappingTaskBody,
    [TaskType.FILE]: null,
    [TaskType.TRANSACTION]: null,
    [TaskType.QUESTION]: null,
    [TaskType.INVITE_ACCOUNTANT]: null,
    [TaskType.RECEIPT_PHONE_NUMBER]: null,
    [TaskType.MAP_CHART_OF_ACCOUNTS]: null,
    [TaskType.XERO_FILE_UPLOAD]: null,
    [TaskType.QBDT_FILE_UPLOAD]: null,
    [TaskType.SCHEDULE_SOURCE_CHANGE_REVIEW]: null,
};
